module.exports = __webpack_public_path__ + "img/chord-label-G.7e9dd3b6.png";